<template>
  <div class="house">
    <div class="main" @click="removeDesc">
      <div v-on:paste="ctrlVUpload" @click.stop class="uploadhead disflex">
        <h4>
          {{
            !$route.params.atlas
              ? "资源上传"
              : "《" + atlasForm.name + "资源夹》 补充资源"
          }}
          <span
            style="font-size: 12px; margin-left: 20px"
          >
            {{
              "已选择图片数：" + pLength + " 张，视频数：" + vLength + '个'
            }}
          </span>
        </h4>
        <div style="display: flex">
          <el-button
            v-if="0"
            @click="openQrcode"
            class="btn"
            style="margin-right: 20px"
            :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          >
            <div style="display: flex">
              <div class="myicon"></div>手机上传
            </div>
          </el-button>

          <!-- <el-button
            v-if="isAdd && this.$route.params.atlas"
            @click="openQrcodea"
            class="btn"
            style="margin-right: 20px"
            :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          >
            <div style="display: flex">
              <div class="myicon"></div>手机上传
            </div>
          </el-button> -->


          <el-upload
            ref="upload"
            class="upload-demo"
            action="noproblem"
            multiple
            :show-file-list="false"
            :auto-upload="false"
          >
            <!-- <el-button class="btn">
              <i class="el-icon-plus"></i> 添加图片
            </el-button>-->
          </el-upload>
          <div v-show="isEwm" ref="erweima" id="erweima"></div>
          <div v-show="isEwmA" ref="erweimaa" id="erweimaa"></div>
        </div>
      </div>

      <div
        style="display: flex;position: relative;"
        class="piclist"
        v-loading="picLoading"
        element-loading-text="资源正在加载，请耐心等待~"
      >
        <div style="width: calc(100% - 450px); min-height: 805px;" v-on:paste="ctrlVUpload">
          <!-- v-loading="loading"
          :element-loading-text="'图片上传中，进度：' + alreadyUpload + '/' + uploadLength"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.6)"-->

          <template v-if="picList.length > 0">
            <div class="batcch-operation">
              <el-upload
              action="noproblem"
              ref="dragupload1"
              multiple
              :limit="100"
              :on-exceed="handleExceedFirst"
              :show-file-list="false"
              accept="image/*,video/*"
              :auto-upload="false"
              :on-change="onChangeInside"
            >
                  <el-button
                  type="primary"
                  :disabled="isrouteBtn"
                  style="background-color: #18469c;margin-right: 10px;"
                  >
                    <i class="el-icon-plus"></i> 添加资源
                  </el-button>
            </el-upload>
              <div v-if="!batchOperationFlag" >
                
                <el-button 
                type="primary"
                  style="background-color: #18469c;"
                  icon="el-icon-files" 
                  :disabled="isrouteBtn"
                  @click="batchOperation()">
                  批量操作
                </el-button>

              </div>
              <div v-else class="operation-btn">
                <el-button :disabled="isrouteBtn" @click="batchAdd(1,'分类')" type="primary" style="background-color: #18469c;" icon="el-icon-plus">添加分类</el-button>
                <el-button :disabled="isrouteBtn" @click="batchAdd(2,'标签')" type="primary" style="background-color: #18469c;" icon="el-icon-plus">添加标签</el-button>
                <el-button :disabled="isrouteBtn" @click="batchAdd(3,'作者')" type="primary" style="background-color: #18469c;" icon="el-icon-plus">添加作者</el-button>
                <el-button :disabled="isrouteBtn" @click="batchAdd(4,'资源说明')" type="primary" style="background-color: #18469c;" icon="el-icon-edit">编辑资源说明</el-button>
                <el-button :disabled="isrouteBtn" @click="confirmPublic()" type="primary" style="background-color: #18469c;" icon="el-icon-edit">设置为{{ initUploadStatus?'私密':'公开' }}</el-button>
                <el-button :disabled="selecteAllFlag||isrouteBtn" @click="selecteAll()" type="success"  icon="el-icon-check">全选</el-button>
                <el-button :disabled="!selecteAllFlag||isrouteBtn" @click="selecteAllCancel()" type="danger"  icon="el-icon-error">取消全选</el-button>
                
                <el-button @click="openBoxOfBatchDelete()" type="danger" icon="el-icon-delete">删除</el-button>
                <el-button @click="batchOperationCancel()" icon="el-icon-document-delete">收起</el-button>
                
              </div>

            </div>
            <el-upload
              ref="dragupload"
              class="uploaddemo"
              action="noproblem"
              multiple
              :limit="100"
              :on-exceed="handleExceed"
              :show-file-list="false"
              :auto-upload="false"
              drag
              :disabled="loading"
              :on-change="onChangeInside"
              :style="{
                width: '100%',
                height: picList.length < 11 ? '755px' : 'auto',
              }"
            >
              <section>
                <div
                  :class="
                    isUploadFlag === index
                      ? 'img-wrapper imgborder'
                      : 'img-wrapper'
                  "
                  style="position: relative;"
                  @click.stop="picListClick(index,item)"
                  v-for="(item, index) in picList"
                  :key="index"
                >
                  <div  style="position:absolute;left: 0; top: 0;z-index: 10;width:50px;height: 28px;line-height: 28px;background-color: gray;color:white">
                    <div v-if="item.status==0">私密</div>
                    <div v-if="item.status==2">待送审</div>
                    <div v-if="item.status==3">公开</div>
                  </div>
                  <div v-if="batchOperationFlag"  style="position: absolute;right: 0;bottom: 0;">
                    <el-checkbox v-model="item.isChecked" size="large" />
                  </div>
                  <img v-if="item.type == 'pic'" class="img" :src="item.src" />

                  <video style="height:150px;" v-if="item.type == 'video'" :src="item.src"></video>
                  
                  <div class="word" v-if="item.type == 'word'">
                    <div class="title">
                      <img src="@/assets/piclist/wordicon.png" style="margin-right:8px;" alt="">
                      <p :title="item.name">{{item.name}}</p>
                    </div>
                  </div>

                  <div
                    @click.stop="deletePic(item, index)"
                    v-if="isUploadFlag !== index"
                    class="delete"
                  >
                    <img src="@/assets/piclist/delete.png" alt />
                  </div>

                  <div v-if="item.type == 'video' && isUploadFlag !== index" class="open">
                    <img src="@/assets/piclist/play.png" alt />
                  </div>

                  <div v-if="item.desc" :title="item.desc" class="desc">
                    {{
                      item.desc.length > 24
                        ? item.desc.substr(0, 20) + "……"
                        : item.desc
                    }}
                  </div>
                </div>
                <div
                  v-if="loading"
                  class="myloading"
                  :style="{ height: picList.length < 13 ? '805px' : '' }"
                >
                  <div style="text-align: center">
                    <p style="color: #ff8c05; font-size: 26px">{{ progress }}%</p>
                    <div class="container">
                      <div
                        :style="{
                          width: progress + '%',
                          opacity: progress === 0 ? '0' : '1',
                        }"
                        class="warning"
                      ></div>
                      <div class="bj"></div>
                    </div>
                    <p style="color: #fff; font-size: 14px; margin-top: 20px">资源正在上传，请耐心等待<span class="ani_dot"></span></p>
                  </div>
                </div>
              </section>
            </el-upload>
          </template>
          <template v-if="picList.length === 0">
            <el-upload
              class="uploaddemo"
              action="noproblem"
              ref="dragupload1"
              multiple
              :limit="100"
              :on-exceed="handleExceedFirst"
              :show-file-list="false"
              accept="image/*,video/*"
              :auto-upload="false"
              drag
              :on-change="onChangeInside"
            >
              <div class="nopic">
                <div>
                  <img src="@/assets/piclist/upload.png" alt />
                  <p
                    style="
                      text-align: center;
                      margin-bottom: 15px;
                      font-size: 12px;
                      color: #adaaad;
                    "
                  >限制上传50张图片,10个视频</p>

                  <el-button
                    class="btn"
                    :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                  >
                    <i class="el-icon-plus"></i> 添加资源
                  </el-button>
                </div>
              </div>
            </el-upload>
          </template>
          <!-- </el-upload> -->
        </div>

        <el-collapse-transition>
          <div @click.stop v-if="isUpload" :class="picdescribeClass">
            <div style="width: 100px;height: 50px;line-height: 50px;">资源说明：</div>
            <el-input
              id="input"
              class="describeinput"
              @blur="blurDesc"
              v-model="picDescribe"
              placeholder="内容文字不超过200字"
            ></el-input>
          </div>
        </el-collapse-transition>

        <div :class="picinfClass">
          <div class="curtain">
            <h4
              @click="changeUploadMode"
              :style="{ marginLeft: !this.$route.params.atlas ? '' : '-50px' }"
              :class="
                uploadMode === 0 && !this.$route.params.atlas ? isCustom ? custom == 'xugong' ? 'xgactive' : 'wcactive' : isSimple ? 'simpleactive' : 'active' : ''
              "
            >创建新资源夹</h4>
            <!-- <h4 v-if="!this.$route.params.atlas" style="margin-top:-3px">|</h4> -->
            <h4
              v-if="!this.$route.params.atlas"
              @click="changeUploadMode"
              :class="uploadMode === 1 ? isCustom ? custom == 'xugong' ? 'xgactive' : 'wcactive' :  isSimple ? 'simpleactive' : 'active' : ''"
            >归档到资源夹</h4>
          </div>

          <div v-if="uploadMode === 0" class="nr">
            <el-form :model="atlasForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <!-- 归属图库 -->
              <el-form-item prop="libId">
                <div @click.stop class="inputlist">
                  <p>归属资源库</p>
                  <el-cascader
                      style="width: 100%;"
                      :disabled="isSave"
                      v-model="atlasForm.libId"
                      :options="options"></el-cascader>
                  <!-- <el-select
                    class="elinput"
                    style="width: 100%"
                    v-model="atlasForm.libId"
                    placeholder="请选择"
                    :disabled="isSave"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      v-html="'<span style=color:#303030;>' + item.label + '</span>'"
                    ></el-option>
                  </el-select> -->
                </div>
              </el-form-item>

              <!-- 资源集名称 -->
              <el-form-item prop="name">
                <div @click.stop class="inputlist">
                  <p>资源夹名称</p>
                  <el-input
                    class="elinput"
                    style="width: 100%"
                    v-model="atlasForm.name"
                    :disabled="isSave"
                    placeholder="请输入内容"
                  ></el-input>
                </div>
              </el-form-item>

              <!-- 相册说明 -->
              <el-form-item prop="desc">
                <div @click.stop class="inputlist">
                  <p>资源夹说明</p>
                  <el-input
                    type="textarea"
                    :autosize="{ minRows, maxRows }"
                    style="width: 100%"
                    placeholder="请输入内容"
                    v-model="atlasForm.desc"
                    :disabled="isSave"
                  ></el-input>
                </div>
              </el-form-item>

              <!-- 可见性 -->
              <!-- <el-form-item prop="status">
                <div @click.stop class="inputlist">
                  <p>上传资源可见性</p>
                  <el-radio-group
                    :disabled="isSave || statusFlag"
                    v-model="mediaStatus"
                    size="medium"
                    :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                  >
                    <el-radio-button :label="0">私密</el-radio-button>
                    <el-radio-button :label="1">公开</el-radio-button>
                  </el-radio-group>
                </div>
              </el-form-item> -->
              <el-checkbox
                :disabled="isSave"
                style="margin-left: 10px;"
                v-model="isIncludeChinese"
              >使用文件名作为资源说明</el-checkbox>

              <div @click.stop class="btn">
                <el-button
                  :disabled="isrouteBtn"
                  @click.stop="save('ruleForm')"
                  :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                >
                  <i class="save"></i>
                  <span class="text">保存</span>
                </el-button>
                <!-- <el-button
                  v-if="!$route.params.atlas && !isHaveVideo"
                  :disabled="isrouteBtn"
                  :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                  @click.stop="saveandpush('ruleForm')"
                >
                  <i class="push"></i>
                  <span class="text">保存并推送</span>
                </el-button> -->
                <el-button
                  class="fanhui"
                  v-if="$route.params.atlas"
                  :disabled="isrouteBtn"
                  :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                  @click.stop="$router.back(-1)"
                >
                  <i class="fanhuiicon"></i>
                  <span class="text">返回</span>
                </el-button>
              </div>
            </el-form>
          </div>

          <div v-if="uploadMode === 1" class="nr">
            <el-form
              :model="atlasForm"
              @submit.native.prevent
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <!-- 归属图库 -->
              <el-form-item prop="libId">
                <div @click.stop class="inputlist">
                  <p>指定资源夹</p>
                  <el-input
                    class="elinput"
                    style="width: 100%"
                    v-model="myselect"
                    placeholder="请输入关键字进行筛选"
                    @input="myLibChange"
                    :disabled="isSave"
                  >
                    <!-- <el-option
                      v-for="item in myAtlas"
                      :key="item.value.id"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>-->
                  </el-input>
                </div>
              </el-form-item>

              <el-table
                :data="myAtlas"
                stripe
                height="300"
                @row-click="rowClick"
                highlight-current-row
                style="width: 100%; overflow-y: auto"
              >
                <el-table-column prop="name" show-overflow-tooltip label="资源夹名"></el-table-column>
                <el-table-column prop="date" label="创建时间"></el-table-column>
              </el-table>

              <!-- 可见性 -->
              <!-- <el-form-item prop="status">
                <div @click.stop class="inputlist">
                  <p>上传资源可见性</p>
                  <el-radio-group
                    :disabled="isSave || statusFlag"
                    v-model="mediaStatus"
                    size="medium"
                    :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                  >
                    <el-radio-button :label="0">私密</el-radio-button>
                    <el-radio-button :label="1">公开</el-radio-button>
                  </el-radio-group>
                </div>
              </el-form-item> -->
              <el-checkbox
                :disabled="isSave"
                style="margin-left: 10px; margin-top: 20px"
                v-model="isIncludeChinese"
              >使用文件名作为资源说明</el-checkbox>

              <div @click.stop class="btn">
                <el-button
                  :disabled="isrouteBtn"
                  @click.stop="save('ruleForm')"
                  :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                >
                  <i class="save"></i>
                  <span class="text">保存</span>
                </el-button>
                <!-- <el-button
                  :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
                  v-if="!$route.params.atlas && !isHaveVideo"
                  :disabled="isrouteBtn"
                  @click.stop="saveandpush('ruleForm')"
                >
                  <i class="push"></i>
                  <span class="text">保存并推送</span>
                </el-button> -->
                <el-button
                  class="fanhui"
                  v-if="$route.params.atlas"
                  :disabled="isrouteBtn"
                  @click.stop="$router.back(-1)"
                >
                  <i class="fanhuiicon"></i>
                  <span class="text">返回</span>
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <el-dialog width="30%" :before-close="handleCloseOpen" :visible.sync="dialogVisibleOpen">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </el-dialog>

    <!-- 推送列表 -->
    <el-dialog width="24%" :before-close="handleClosePush" :visible.sync="dialogVisiblePush">
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>选择推送渠道</div>
      </div>
      <div class="pushbj">
        <div
          @click.stop="choosePush(i, e.template, e.name, e.id)"
          :class="pushIndex === i ? isSimple ? 'pushlist simpleactive' : 'pushlist active' : 'pushlist'"
          v-for="(e, i) in pushList"
          :key="i"
        >
          {{ e.name }}
          <img v-if="pushIndex === i" src="@/assets/house/checkInside.png" alt />
        </div>
      </div>
    </el-dialog>

    <el-dialog width="26%" :before-close="handleClosePic" :visible.sync="mydialogVisible">
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>推送至图片邀约</div>
      </div>
      <el-form :model="myform" ref="myform" label-width="70px" :rules="myformRules">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>-->
        <el-form-item label="标题：" prop="name">
          <el-select
            style="width: 100%"
            v-model="myform.name"
            filterable
            @change="myformChange"
            clearable
            placeholder="请选择标题"
          >
            <el-option
              v-for="(e, i) in picInviteList"
              :key="i"
              :label="e.title"
              :value="e.title"
              v-html="'<span style=color:#303030;>' + e.title + '</span>'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label" class="labelclass">备注：</div>
          <el-input type="textarea" :autosize="{ minRows: 7 }" v-model="myform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button
          type="primary"
          :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          @click="submitPic('myform')"
        >提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog width="26%" :before-close="handleCloseUser" :visible.sync="dialogVisibleUser">
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>推送至用户</div>
      </div>
      <el-form :model="userForm" ref="userForm" label-width="100px" :rules="userRules">
        <el-form-item label="标题：" prop="name">
          <el-input v-model="userForm.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择用户：" prop="user">
          <!-- multiple -->
          <el-select
            :remote-method="selectUser"
            remote
            v-model="userForm.user"
            filterable
            style="width:100%;"
            placeholder="请选择用户"
          >
            <el-option
              style="width:100%;"
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-html="'<span style=color:#303030;>' + item.name + '</span>'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label" class="labelclass">备注：</div>
          <el-input type="textarea" :autosize="{ minRows: 7 }" v-model="userForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseUser">取 消</el-button>
        <el-button
          type="primary"
          :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          @click="submitUser('userForm')"
        >提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog width="26%" :before-close="dfhandleClosePic" :visible.sync="dfdialogVisible">
      <div
        slot="title"
        class="header-title"
        :style="{ 'padding': '15px 20px', 'box-sizing': 'border-box', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
      >
        <div>推送至东方网融媒体平台</div>
      </div>
      <el-form :model="dfmyform" ref="dfmyform" label-width="70px" :rules="dfrules">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>-->
        <el-form-item label="标题：" prop="name">
          <el-input v-model="dfmyform.name"></el-input>
        </el-form-item>
        <el-form-item>
          <div slot="label" class="labelclass">备注：</div>
          <el-input type="textarea" :autosize="{ minRows: 7 }" v-model="dfmyform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button
          type="primary"
          :style="{ 'border': 'none', 'backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3' }"
          @click="dfsubmitPic('dfmyform')"
        >提 交</el-button>
      </div>
    </el-dialog>




    <el-dialog width="26%"
               :before-close="handleCloseLive"
               :visible.sync="dialogVisibleLive">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至直播活动</div>
      </div>
      <el-form :model="liveform"
               ref="liveform"
               label-width="70px"
               :rules="ruleslive">
        <el-form-item label="标题："
                      prop="id">
          <el-select :remote-method="selectPicTitle"
                     @focus="setMaxWidthPic"
                     @change="liveformChange"
                     remote
                     filterable
                     style="width:100%;"
                     v-model="liveform.title"
                     placeholder="请选择标题">
            <el-option v-for="(e,i) in liveList"
                       :style="{'width': maxWidthPic + 2 + 'px'}"
                       :key="i"
                       :label="e.title"
                       :value="e"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="liveform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseLive">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitLive('liveform')">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 添加分类 -->
    <el-dialog
      :visible.sync="batchDialogFlag"
      width="800px"
      >
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>批量添加{{ batchDialogTitle }}</div>
      </div>
      <div v-if="batchDialogType==1">
        <el-radio-group v-model="selectedClassifyId">
              <el-radio style="width: 170px;margin-bottom:10px ;" :label="item.id" v-for="item in classifyList" :key="item.id">{{ item.name }}</el-radio>
        </el-radio-group>
      </div>
      <div v-if="batchDialogType==2" style="display: flex;justify-content: center;align-items: center;">
        <el-transfer
          filterable
          :props="{ key: 'id', label: 'labelName' }"
          :titles="['标签列表','已选标签']"
          :filter-method="filterMethod"
          filter-placeholder="请输入关键字检索"
          v-model="selectedLabelList"
          :data="labelList">
          <div slot="left-footer" style="padding:5px;display:flex;align-items: center;">
            <el-button type="primary" :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" @click="addLabel()"  size="small">
            新增标签
          </el-button>
          </div>
          <div slot="right-footer" style="padding:5px;font-size:10px;color:red;display:flex;align-items: center;">
            
          </div>
        </el-transfer>

      </div>
      <div v-if="batchDialogType==3">
        <div style="display: flex;flex-wrap: nowrap;justify-content: center;align-items: center;">
          <div style="width:90px">
            填写作者：
          </div>
          <el-input v-model="author" placeholder="请填写作者名称" maxlength="20" minlength="2"></el-input>
        </div>
      </div>
      <div v-if="batchDialogType==4">
        <el-input
        id="input"
        class="describeinput"
        type="textarea"
        maxlength="200"
        :show-word-limit="true"
        :rows="3"
        :autosize="{ minRows: 3, maxRows: 6 }"
        v-model="picDescribe"
        placeholder="内容文字不超过200字"
      >
      </el-input>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelOperation()">取 消</el-button>
        <el-button 
          type="primary"
          :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" 
          @click="confirmOperation">确 定</el-button>
      </span>
    </el-dialog>
    <mydialog @changedialogFormVisible="changedialogFormVisible"
              @dialogSubmit="dialogSubmit"
              :title="title"
              :myform="labelForm"
              :label="label"
              :needStatus="false"
              :dialogFormVisible="tableDialogFormVisible"></mydialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { labeldialog } from '@/components/index'
import {logout }from '@/plugins/logout.js'
import getMD5 from "@/plugins/getMD5";
import { getDate, formatConversion } from "@/plugins/getdate";
import { listLib } from "@/api/lib";
import { myPictureNeed } from "@/api/pictureNeed";
import { getClassifyListApi } from "@/api/classify";
import { getLabelListApi,addLabelApi } from "@/api/label"
import { formatDateTime } from "@/plugins/util"
import {
  uploadPic,
  batchCheck,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash,
} from "@/api/file";
import { listUser } from "@/api/user";
import { addAtlas } from "@/api/atlas";
import { addPicture } from "@/api/picture";
import { addVideo } from "@/api/video";
import { getMobileUpdateUrl } from "@/api/userCenter";
import { allowLib, powersObj, powersList } from "@/constants/powers";
import { getAppBaseConfig } from "@/api/config";
import { searchAtlas } from "@/api/search";
import { addPicturePackage } from "@/api/picturePackage";

import { myActivityLive } from "@/api/activityLive";

import { listAllowPushChannel } from "@/api/pushChannel";


import { save,create,selectList } from "@/api/word";
import { picPrefix } from "@/constants/piccommon";

import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  inject: ["reload"],
  components: {
    'mydialog': labeldialog
  },
  watch: {
    picList(data) {
      this.picFlag = true;
    },
    tableDialogFormVisible (data) {
      this.tableDialogFormVisible = data;
    },
    
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data() {
    return {
      canUploadFlag:true,
      //是否可以添加图片到图集
      isAdd:false,
      dialogFormVisible: false,
      mediaLength:0, 
      label: ['标签名称', '排序'],
      title: '新增标签',
      labelForm: { one: "", two: "" },
      tableDialogFormVisible: false,
      picIds: [],
      videoIds:[], 
      picPrefix,
      //是否含有视频
      isHaveVideo:false,

      //推送至东方
      dfdialogVisible: false,
      dfmyform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ''
      },
      dfrules: {
        name: [{ required: true, message: "请填写标题", trigger: "change" }],
      },

      //推送到用户
      dialogVisibleUser: false,
      isAuditEnabled:false,
      userForm: {
        name: "",
        user: "",
        createUid: this.createUid,
        note: ""
      },
      userRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        user: [{ required: true, message: "请选择用户", trigger: "change" }],
      },
      userList: [],

      //推送至直播
      dialogVisibleLive: false,
      liveform: {
        title: "",
        note: "",
        createUid: this.createUid,
        id: ''
      },
      ruleslive: {
        id: [{ required: true, message: "请选择标题", trigger: "change" }],
      },
      liveList: [],
      mediaStatus:0,

      //可见性的权限设置
      statusFlag: false,
      //内部域名
      privateDomain: "",

      //屏幕高度
      documentHeight: 0,

      minRows: 6,
      maxRows: 10,

      //权限
      powersList,
      powersObj,
      allowLib,

      //进度条
      progress: 0,
      kuai: "",

      //图片名称是否包含中文
      isIncludeChineseFlag: true,

      //选中图集信息
      atlasInfo: {},

      //图集信息
      atlasForm: {
        libId: "",
        name: "",
        desc: "",
        status: "",
        sourceType: "0",
        indexpicId: "0",
        createUid: this.createUid,
      },
      rules: {
        name: [
          { min: 0, max: 60, message: "长度在 60 个字符以内", trigger: "blur" },
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度在 200 个字符以内",
            trigger: "blur",
          },
        ],
        libId: [
          { required: true, message: "请选择归属资源夹", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择可见性", trigger: "change" },
        ],
      },

      fileList: [],

      //是否显示手机上传的二维码
      isEwm: false,
      isEwmA: false,

      loading: false,
      uploadLength: 0,
      alreadyUpload: 0,

      //归档到图集的ID
      atlasId: 0,
      libId: 0,
      uploadFilesFlag: 1,
      isIncludeChinese: false,

      isUpload: false,
      isUploadFlag: -1,
      picDescribe: "",

      picFlag: true,
      //出错图片
      myErrorList: [],
      picList: [],
      uploadPicList: [],
      picListCopy: [],
      options: [],
      visibilityList: [
        {
          value: "1",
          label: "公开",
        },
        {
          value: "0",
          label: "私密",
        },
      ],

      isError: 0,
      isSave: false,
      isrouteBtn: false,

      picinfClass: "picinf",
      picdescribeClass: "picdescribe",

      picLoading: false,
      picLength: 0,

      uploadErrorLength: 0,

      //归属到个人资源库
      myLibId: 0,
      myAtlasId: 0,
      myselect: "",
      myAtlas: [],

      uploadMode: 0,

      //播放
      dialogVisibleOpen: false,
      pLength: 0,
      vLength: 0,
      wLength: 0,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },

      //推送
      dialogVisiblePush: false,
      mydialogVisible: false,
      pushList: [],
      pushIndex: 0,
      template: '',

      pushChannelId: '',
      pushChannelName: '',

      picId: [],
      picInviteList: [],
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: "",
      },
      myformRules: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }],
      },

      //option最大宽度
      maxWidthPic: 0,
      //删除的数据
      delList: [],
      batchOperationFlag: false,
      dialogVisible: false,

      batchDialogType:0,   //默认0，  1分类，2标签，3作者，4编辑资源说明
      batchDialogFlag: false,
      batchDialogTitle:'',
      // 批量添加分类
      selecteAllFlag:true,
      
      classifyList:[],
      selectedClassifyId:undefined,

      // 批量添加标签
      labelDialog:false,
      labelList: [],
      selectedLabelList: [],

      // 批量添加作者
      authorDialog:false,
      author: '',
      currentPage: 1,
      addLabelName:'' ,
      labelName: '',
      initUploadStatus:2,//资源上传初始状态 
    };
  },
  methods: {
    ...mapActions(["setErrorList"]),

    /***
     * @name 添加标签dialog
     */
    addLabel () {
      this.tableDialogFormVisible = true;
      this.labelForm = { one: this.addLabelName.trim(), two: "0",three:1 }
      // this.$router.push('/contributor')
    },
    changedialogFormVisible (data) {
      this.tableDialogFormVisible = data;
    },
    dialogSubmit (data) {
      let { systemDate } = getDate();
      let willToPushData = {
        "labelName": data.one,
        "sort": data.two,
        "status": 1,
      };
      this.addLibAsync(willToPushData)
    },
    async addLibAsync (val) {
      let { status, data, message, errors } = await addLabelApi(val);
      if (status) {
        this.changedialogFormVisible(false)
        this.$message.success("添加成功！");
        this.listLabelAsync()

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    // 穿梭框的参数筛选
    filterMethod(query, item) {
      this.addLabelName = query;
      return item.labelName.indexOf(query.trim()) > -1;
    },

    /***
     * @name 批量操作
     * @param index =>1分类，2标签，3作者，4资源说明
     * @param title=>dialog框标题
     */
    batchAdd(index, title) {
      this.batchDialogType = index;
      this.batchDialogFlag = true;
      this.batchDialogTitle = title
      let selectedPicList = this.picList.filter((item) => item.isChecked)
      if (selectedPicList.length > 1) {
        if (index == 1) {        
          this.selectedClassifyId = ''
        } else if (index == 2) {        
          this.selectedLabelList = []        
        } else if (index == 3) {
          this.author = '' 
        } else if (index == 4) {
          this.picDescribe = ''
        };
}
      

    },

    confirmPublic() {
      if (this.isAuditEnabled=='true') {
        this.$confirm(
          `此操作，选中的资源将会${this.initUploadStatus?'私密':'进行审核'}, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
          }
        ).then(() => {
          this.$message.success('操作成功！')
          this.picList.forEach((element) => {
            if (this.initUploadStatus) {
              element.status=element.isChecked?0:2
            } else {
              element.status=element.isChecked?2:0
            }
            
          })
          this.uploadPicList.forEach((element) => {
            if (this.initUploadStatus) {
              element.status=element.isChecked?0:2
            } else {
              element.status=element.isChecked?2:0
            }
          })
        });
      } else {
        this.$confirm(
          `选中的资源将会${this.initUploadStatus?'私密':'公开'}, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
          }
        ).then(() => {
          this.$message.success('操作成功！')
          this.picList.forEach((element) => {
            if (this.initUploadStatus) {
              element.status=element.isChecked?0:3
            } else {
              element.status=element.isChecked?3:0
            }
          })
          this.uploadPicList.forEach((element) => {
            if (this.initUploadStatus) {
              element.status=element.isChecked?0:3
            } else {
              element.status=element.isChecked?3:0
            }
          })
        });
      }
      
    },

    selecteAll() {
      this.uploadPicList.forEach((item) => {
        item.isChecked=true
      })
      this.picList.forEach((item) => {
        item.isChecked=true
      })
      this.selecteAllFlag=true
    },
    selecteAllCancel() {
      this.uploadPicList.forEach((item) => {
          item.isChecked=false
        })
      this.picList.forEach((item) => {
        item.isChecked=false
      })
      this.selecteAllFlag=false
    },
    

    // dialog确认操作或取消操作
    cancelOperation(){
      this.batchDialogFlag = false
    },
    confirmOperation(){
      
      if (this.batchDialogType == 1) {
        if (this.selectedClassifyId == '') {
          this.$message.warning('添加分类不能为空，请选择！')
          return   
        }  
        this.uploadPicList.forEach((item) => {
          if (item.isChecked) {
            item.accessId = this.selectedClassifyId
            console.log('已添加分类'); 
            
          }
        })
        this.picList.forEach((item) => {
          if (item.isChecked) {
            console.log('已添加分类'); 
            item.accessId=this.selectedClassifyId

          }
        })
      } else if (this.batchDialogType == 2) {
        if (this.selectedLabelList.length==0) {
          this.$message.warning('添加标签不能为空，请选择！')
          return   
        } 
        this.uploadPicList.forEach((item) => {
          if (item.isChecked) {
            item.labelIds = this.selectedLabelList.join(',')
            console.log('已添加标签');   
              
          }
        })
        this.picList.forEach((item) => {
          if (item.isChecked) {
            item.labelIds = this.selectedLabelList  .join(',')
           console.log('已添加标签');   
             
          }
        })
      } else if (this.batchDialogType == 3) {
        if (this.author == '') {
          this.$message.warning('添加作者不能为空，请填写！')
          return   
        } 
        this.uploadPicList.forEach((item) => {
          if (item.isChecked) {
            item.author = this.author 
           console.log('已添加作者');   
              
          }
        })
        this.picList.forEach((item) => {
          if (item.isChecked) {
            item.author = this.author  
           console.log('已添加作者');   
          }
        })
      } else {
        if (this.picDescribe == '') {
          this.$message.warning('添加资源说明不能为空，请填写！')
          return   
        } 
        this.uploadPicList.forEach((item) => {
          if (item.isChecked) {
            item.desc =this.picDescribe  
            console.log('已添加资源说明');  
          }
          
        })
        this.picList.forEach((item) => {
          if (item.isChecked) {
            item.desc =this.picDescribe  
            console.log('已添加资源说明');  
          }
        })
      }
      this.batchDialogFlag = false;
    },
    openBoxOfBatchDelete() {
      let picList = this.picList.filter((ele) => ele.isChecked)
      if (picList.length==0) {
        this.$message.warning('删除内容不能为空，请选择！')
        return
      }    
      this.$confirm('此操作将批量删除选中文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.batchDelete()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    //批量删除图片
    batchDelete() {

      this.picList = this.picList.filter((ele) => !ele.isChecked)
      this.selecteAllFlag=false
      console.log(this.picList);
      let picLengthArr = this.picList.filter((ele) => ele.type == 'pic');
      this.pLength= picLengthArr.length
      let videoLengthArr = this.picList.filter((ele) => ele.type=='video')
      this.vLength=videoLengthArr.length
      
      this.uploadPicList = this.uploadPicList.filter((ele) => !ele.isChecked)
      this.$message.success("批量删除成功！");
    },
    //批量操作
    batchOperation(){
      this.batchOperationFlag = true;
      this.picList.forEach((element)=>{
        element.isChecked=true
      })
      this.uploadPicList.forEach((element)=>{
        element.isChecked=true
      })
    },
    batchOperationCancel() {
      this.batchOperationFlag = false;
      this.selecteAllFlag = true;
      this.picList.forEach((element)=>{
        element.isChecked = false    
      })
      this.uploadPicList.forEach((element)=>{
        element.isChecked = false
      })
    },
    handleCheckedChange(item,index) {
      console.log(item, index);
      this.uploadPicList[index].isChecked = !this.uploadPicList[index].isChecked
     console.log(this.uploadPicList[index]); 
      item.isChecked = !item.isChecked
      let selectedPicList = this.picList.filter((item) => item.isChecked) 
      // if (this.picList.length>selectedPicList.length) {
      //   this.selecteAllFlag=false
      // }
      this.selecteAllFlag =this.picList.length>selectedPicList.length? false:true
      console.log(item.isChecked);
    },

    //直播关闭
    handleCloseLive () {
      this.$refs['liveform'].resetFields();

      this.dialogVisibleLive = false;

    },
    //设置option最大宽度
    setMaxWidthPic (val) {
      this.maxWidthPic = val.srcElement.clientWidth
    },
    //直播名筛选
    selectPicTitle (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query }
        this.myActivityLiveAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20 }
        this.myActivityLiveAsync(dataExa)
      }
    },
    //直播选择
    liveformChange (val) {
      this.liveform.title = val.title;
      this.liveform.id = val.id;
    },

    //获取我的直播
    async myActivityLiveAsync (val) {
      let { status, data, message, errors } = await myActivityLive(val);
      if (status) {
        this.liveList = data
        if(this.liveList.length > 0){
          this.liveform.id = this.liveList[0].id
          this.liveform.title = this.liveList[0].title
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },



    //直播推送
    submitLive (form) {
      this.$refs[form].validate(valid => {
        if (valid) {

          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'push',
            pictureCount: this.picId.length,
            pictureIds:this.picId.toString(),
            title: this.liveform.title,
            pushConfig: JSON.stringify({ pushChannelId: 'live',activityLiveId:this.liveform.id, note: this.liveform.note }) || ''
          }

          this.addPicturePackageAsync(choosePicMsg);
          this.handleCloseLive()
          setTimeout(() => {
            this.$router.push('/shareAndPush/myPush')
          }, 1500);
        }
      })
    },











    handleCloseOpen() {
      this.dialogVisibleOpen = false
    },
    myformChange(val) {
      this.myform.name = val.title;
      this.myform.id = val.id;
    },
    //东方网推送
    //东方网融媒体平台关闭
    dfhandleClosePic() {
      this.$refs['dfmyform'].resetFields();
      this.dfdialogVisible = false;
    },

    //东方推送
    dfsubmitPic(form) {
      this.$refs[form].validate(valid => {
        if (valid) {

          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'push',
            pictureCount: this.picId.length,
            pictureIds: this.picId.toString(),
            title: this.dfmyform.name,
            targetUid: 0,
            pushConfig: JSON.stringify({
              pushChannelId: this.pushChannelId,
              note: this.dfmyform.note,
            }),
          };

          this.addPicturePackageAsync(choosePicMsg);
          this.dfdialogVisible = false
          setTimeout(() => {
            this.$router.push('/shareAndPush/myPush')
          }, 1500);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //推送相关
    handleClosePush() {
      this.dialogVisiblePush = false
    },
    handleClosePic() {
      this.mydialogVisible = false;
    },
    //推送选择
    choosePush(i, t, name, id) {
      this.pushIndex = i;
      this.template = t;
      this.pushChannelId = id;
      this.pushChannelName = name;

      this.pushUpload()

      this.dialogVisiblePush = false;
    },

    //获取图片邀约列表
    async listPictureNeedAsync(val) {
      let { status, data, message, pagination, errors } = await myPictureNeed(
        val
      );
      if (status) {
        this.picInviteList = data;

        this.myform.name = this.picInviteList[0].title;
        this.myform.id = this.picInviteList[0].id;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //获取允许的推送渠道
    async listAllowPushChannelAsync() {
      let { status, data, message, errors } = await listAllowPushChannel();
      if (status) {
        this.pushList = data;

        this.template = this.pushList[0].template;

        this.dialogVisiblePush = true;
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      }
    },

    submitPic(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          for (let i = 0; i < this.picInviteList.length; i++) {
            if (this.picInviteList[i].title == this.myform.name) {
              this.myform.id = this.picInviteList[i].id
            }
          }
          // console.log(1)
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'push',
            pictureCount: this.picId.length,
            pictureIds: this.picId.toString(),
            title: this.myform.name,
            pushConfig: JSON.stringify({
              pushChannelId: this.pushChannelId,
              pictureNeedId: this.myform.id,
              note: this.myform.note,
            }),
          };

          this.addPicturePackageAsync(choosePicMsg);
          setTimeout(() => {
            this.$router.push("/shareAndPush/myPush");
          }, 1500);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //增加图片包
    async addPicturePackageAsync(val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("创建成功！");
        this.mydialogVisible = false;
        this.dialogVisiblePush = false;
        this.dialogVisibleUser = false
        setTimeout(() => {
          this.$router.push("/shareAndPush/myPush");
        }, 1000);
        // this.setDrawer(false)
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.mydialogVisible = false;
        this.dialogVisiblePush = false;
      }
    },

    //推送
    pushPicHaveAtlasId() {
      if (this.template === "picture-website") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/show",
          query: {
            isSavePic: true,
            name: this.pushChannelName,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (this.template === "routersoft-qms") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/qms",
          query: {
            isSavePic: true,
            name: this.pushChannelName,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "routersoft-rmt" ||
        this.template === "routersoft-mcp"
      ) {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/mcp",
          query: {
            isSavePic: true,
            name: this.pushChannelName,
            isDrawer: false,
            id: this.atlasId,
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "picture-need" ||
        this.template === "system-picture-need"
      ) {
        this.mydialogVisible = true;
        this.dialogVisiblePush = false;
      } else if (this.template === 'picture-user') {
        this.dialogVisibleUser = true
        this.listUserAsync({ userType: 0 })
      }
    },

    //推送
    pushPic() {
      console.log(this.picId);
      if (this.template === "picture-website") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/show",
          query: {
            isSavePic: true,
            name: this.pushChannelName,
            isDrawer: false,
            ids: this.picId.toString(),
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (this.template === "routersoft-qms") {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/qms",
          query: {
            isSavePic: true,
            name: this.pushChannelName,
            isDrawer: false,
            ids: this.picId.toString(),
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "routersoft-rmt" ||
        this.template === "routersoft-mcp"
      ) {
        this.pushdialogVisible = false;
        this.$router.push({
          path: "/shareAndPush/push/mcp",
          query: {
            isSavePic: true,
            name: this.pushChannelName,
            isDrawer: false,
            ids: this.picId.toString(),
            pushChannelId: this.pushChannelId,
          },
        });
      } else if (
        this.template === "picture-need" ||
        this.template === "system-picture-need"
      ) {
        this.mydialogVisible = true;
        this.dialogVisiblePush = false;
      } else if (this.template === 'picture-user') {
        this.dialogVisibleUser = true
        this.listUserAsync({ userType: 0 })
      } else if (this.template === "eastnet-mc") {
        this.dfdialogVisible = true
      } else if (this.template === "activity-live") {
          this.dialogVisibleLive = true
          this.myActivityLiveAsync({page:0,pageSize:20})
        }
    },

    handleCloseUser() {
      this.dialogVisibleUser = false;
    },

    //用户名筛选
    selectUser(query) {
      let dataExa
      if (query !== '') {
        dataExa = { userType: 0, keyword: query }
        this.listUserAsync(dataExa)
      } else {
        dataExa = { userType: 0 }
        this.listUserAsync(dataExa)
      }
    },

    // 推送到用户
    submitUser(form) {
      this.$refs[form].validate(valid => {
        if (valid) {

          // console.log(1)
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'push',
            pictureCount: this.picId.length,
            pictureIds: this.picId.toString(),
            title: this.userForm.name,
            targetUid: this.userForm.user,
            pushConfig: JSON.stringify({
              pushChannelId: this.pushChannelId,
              note: this.userForm.note,
            }),
          };

          this.addPicturePackageAsync(choosePicMsg);


          this.$nextTick(() => {
            // this.$router.push('/shareAndPush/myPush')
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //获取用户列表
    async listUserAsync(val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        this.userList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    pushUpload() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          //判断是否把文件名作为图片描述
          if (this.isIncludeChinese) {
            for (let i = 0; i < this.uploadPicList.length; i++) {
              let descMy = "";
              this.uploadPicList[i].desc = "";
              // this.picList[i].desc = "";
              let nameMy = this.uploadPicList[i].name.substring(
                0,
                this.uploadPicList[i].name.length - 4
              );
              let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
              //判断当前图片的描述是否为空（因为用户输入的为先，不覆盖）
              if (
                typeof this.uploadPicList[i].desc == "undefined" ||
                this.uploadPicList[i].desc == null ||
                this.uploadPicList[i].desc == ""
              ) {
                if (reg.test(nameMy)) {
                  this.uploadPicList[i].desc = nameMy;
                  this.picList[i].desc = nameMy;
                }
              }
            }
          }


          if (this.uploadMode === 0) {
            if (this.$route.params.atlas) {
              if (!this.isIncludeChinese) {
                let picdesc = ''
                if (this.$route.params.atlas.desc && this.$route.params.atlas.desc !== this.$route.params.atlas.name) {
                  picdesc =
                    this.$route.params.atlas.name +
                    "-" +
                    this.$route.params.atlas.desc;
                } else {
                  picdesc =
                    this.$route.params.atlas.name
                }

                if (picdesc.length > 200) {
                  picdesc = picdesc.substr(0, 195) + "……";
                }
                for (let i = 0; i < this.uploadPicList.length; i++) {
                  if (!this.uploadPicList[i].desc) {
                    this.uploadPicList[i].desc = picdesc;
                    this.picList[i].desc = picdesc;
                  }
                }
              }
              this.isUploadFlag = 0;
              this.isrouteBtn = true;
              this.loading = true;
              this.uploadLength = this.picList.length;
              this.myUpload('push');
            } else {
              if (this.atlasForm.name) {
                if (!this.isIncludeChinese) {
                  let picdesc
                  if (this.atlasForm.desc && this.atlasForm.desc !== this.atlasForm.name) {
                    picdesc = this.atlasForm.name + "-" + this.atlasForm.desc;
                  } else {
                    picdesc = this.atlasForm.name
                  }
                  if (picdesc.length > 200) {
                    picdesc = picdesc.substr(0, 195) + "……";
                  }

                  for (let i = 0; i < this.uploadPicList.length; i++) {
                    if (!this.uploadPicList[i].desc) {
                      this.uploadPicList[i].desc = picdesc;
                      this.picList[i].desc = picdesc;
                    }
                  }
                }
                this.isSave = true;
                this.isrouteBtn = true;
                this.isUploadFlag = 0;
                this.loading = true;
                this.uploadLength = this.picList.length;
                this.addAtlasAsync(this.atlasForm, 'push');
              } else {
                this.$confirm(
                  "此操作，将上传到未整理图片中, 是否继续?",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
                  }
                ).then(() => {
                  this.libId = 0;
                  this.atlasId = 0;
                  this.isSave = true;
                  this.isUploadFlag = 0;
                  this.isrouteBtn = true;
                  this.loading = true;
                  this.uploadLength = this.picList.length;
                  this.myUpload('push');
                });
              }
            }
          } else {
            if (this.myLibId !== 0) {

              if (!this.isIncludeChinese) {
                let picdesc = ''
                if (this.atlasInfo.atlasDesc && this.atlasInfo.atlasDesc !== this.atlasInfo.atlasName) {
                  picdesc =
                    this.atlasInfo.atlasName +
                    "-" +
                    this.atlasInfo.atlasDesc;
                } else {
                  picdesc =
                    this.atlasInfo.atlasName
                }

                if (picdesc.length > 200) {
                  picdesc = picdesc.substr(0, 195) + "……";
                }
                for (let i = 0; i < this.uploadPicList.length; i++) {
                  if (!this.uploadPicList[i].desc) {
                    this.uploadPicList[i].desc = picdesc;
                    this.picList[i].desc = picdesc;
                  }
                }
              }

              this.libId = this.myLibId;
              this.atlasId = this.myAtlasId;
              this.isSave = true;
              this.isUploadFlag = 0;
              this.alreadyUpload = 0;
              this.uploadLength = 0;
              this.isrouteBtn = true;
              this.loading = true;
              this.uploadLength = this.picList.length;
              this.myUpload('push');
            } else {
              this.$message.warning("请选择资源夹");
            }
          }
        }
      });
    },
























    //切换上传方式（创建新图集或归档到图集）
    changeUploadMode() {
      if (this.uploadMode === 0) {
        this.uploadMode = 1;
      } else {
        this.uploadMode = 0;
      }
    },

    //归档到图集
    rowClick(row) {
      this.atlasInfo = row
      if (!this.loading) {
        this.myLibId = row.libId;
        this.myAtlasId = row.atlasId;
      }
    },
    myLibChange() {
      // console.log(this.myselect)
      if (!this.myselect) {
        this.myAtlas = [];
        this.searchAtlasAsync({
          pageSize: 20,
          page: 0,
          createUid: this.createUid,
        });
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = [];
        this.searchAtlasAsync({
          keyword: this.myselect,
          pageSize: 50,
          page: 0,
          createUid: this.createUid,
        });
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    //打开手机上传的二维码
    openQrcode() {
      if (this.privateDomain) {
        this.isEwm = !this.isEwm;
        if (this.isEwm === true) {
          this.$refs.erweima.innerHTML = "";
          this.getMobileUpdateUrlAsync();
        }
      } else {
        this.$message.warning("请管理员配置相关参数！");
      }
    },

    //打开手机上传的二维码
    async openQrcodea() {
      if (this.privateDomain) {
        this.isEwmA = !this.isEwmA;
        if (this.isEwmA === true) {
          this.$refs.erweimaa.innerHTML = "";
          let { status, data, message } = await getMobileUpdateUrl();
          if (status) {
            let liblist = []
            for (let i = 0; i < this.powersList.length; i++) {
              if(this.powersList[i].indexOf('lib') !== -1){
                liblist.push(this.powersList[i])
              }
            }

            let date = new Date(data.expirationTime);
            date = date.getTime(date);
            let qrcode = new QRCode("erweimaa", {
              width: 251,
              height: 259,
              // text:
              //   this.privateDomain 
              //   +
              //   '/mobileAtlas' +
              //   "?token=" +
              //   data.token +
              //   "&date=" +
              //   date +
              //   "&createUid=" +
              //   this.createUid +16335
              //   "&atlasId=" +
              //   this.$route.params.atlas.id +
              //   "&libId=" +
              //   this.$route.params.atlas.libId +
              //   "&haveTimeOut=false" // 二维码地址
              text: ' http://localhost:8080' + '/mobileAtlas' + "?token=" + data.token + "&powers=" + JSON.stringify(liblist) + 
                '&date=' + date + "&atlasId=" + '16335' + "&libId=" + '3' + '&createUid=' + this.createUid + "&haveTimeOut=false", // 二维码地址
              // text: 'http://192.168.187.195:8080/public/mobileUpdate?eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJSb3V0ZXJTb2Z0Q2RwIiwiZXhwIjoxNTkyODgxNzkxLCJ1c2VySWQiOjYwMDAwLCJpYXQiOjE1OTI4Nzk5OTF9.rO_qfy2jf2gDl_w0K_XFb2dBK07H_Gm6kvxjBErMl28', // 二维码地址
            });
          }
        }
      } else {
        this.$message.warning("请管理员配置相关参数！");
      }
    },

    //删除图片
    deletePic(item, index) {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then((e) => {
          if (item.type == 'video') {
            --this.vLength
          } else if (item.type == 'pic'){
            --this.pLength
          } else if (item.type == 'word'){
            --this.wLength
          }
          --this.picLength
          this.picList.splice(index, 1);
          this.uploadPicList.splice(index, 1);
          this.delList.push(item)
          let nowList = this.picList.filter((e)=>{return e.type == 'video'})
          if(nowList.length == 0){
            this.isHaveVideo = false
          }
          this.$message.success("删除成功");
        })
        .catch((e) => {
          // console.log("取消", i);
        });
    },

    //限制图片个数事件
    handleExceedFirst(files, fileList) {
      this.$message.warning(
        `当前限制选择 100 个文件，您选择了 ${files.length} 个文件`
      );
    },

    //限制图片个数事件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 100 个文件，您选择了 ${files.length + this.picList.length} 个文件`
      );
    },

    //粘贴截图内容
    ctrlVUpload(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      let file = null;

      if (!items || items.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        this.$message.error("粘贴内容非图片");
        return;
      }
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var img = new Image();
      let myFile = {
        size: file.size,
        raw: file,
      };
      reader.onload = function(e) {
        var width = 160, //图像大小
          quality = 0.8, //图像质量
          canvas = document.createElement("canvas"),
          drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function() {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);

          ++_this.picLength;
          // img.src = canvas.toDataURL("image/png", quality);
          // console.log(canvas.toDataURL("image/png", quality))

          _this.picList.push({
            name: file.name,
            src: canvas.toDataURL("image/png", quality),
            desc: "",
            author: '',
            labelIds: '',
            accessId: '',
            status:0, 
            file: myFile,
            isChecked:this.batchOperationFlag
          });
        };

        _this.uploadPicList.push({
          name: file.name,
          src: this.result,
          desc: "",
          file: myFile,
          isChecked:this.batchOperationFlag
        });
      };

      this.$refs.upload.uploadFiles.push(file);
    },

    //第二个上传按钮的change事件
    onChangeInside(file, fileList) {
      console.log('上传文件',file);
      console.log('前',fileList);
      if(this.delList.length > 0){
        let fList = []

        for (const item1 of fileList) {
          let flag = true;
          for (const item2 of this.delList) {
            if(item1.uid == item2.file.uid){
              flag = false
            }
          }

          if(flag){
            fList.push(item1)
          }
        }

        fileList = fList
      }


      console.log('后',fileList);

      this.picLoading = true;



      if (file.size == 0 ) {
          this.$message.error(
            "上传资源不能为空，已为您删除了不符合要求的资源!"
          );
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].uid === file.uid) {
              if (i == fileList.length - 1) {
                this.picLoading = false;
              }
              fileList.splice(i, 1);
            }
          }
          if (fileList.length == 0) {
            this.picLoading = false;
          }
          return false;
      }
      let video = fileList.filter((e) => { return e.raw.type == 'video/mp4' || e.raw.type == 'video/quicktime' })
      let videoLength = video.length
      if (videoLength >= 11) {
        this.$message.warning(
          `当前限制选择 10 个视频！`
        );
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].uid === file.uid) {
            if (i == fileList.length - 1) {
              this.picLoading = false;
            }
            fileList.splice(i, 1);
          }
        }
        this.picLoading = false;
        return false;
      }
      let picture = fileList.filter((e) => { return e.raw.type == 'image/jpeg' || e.raw.type == 'image/png'  || e.raw.type == 'image/gif'})
      let picturnLength = picture.length
      if (picturnLength >= 51) {
        this.$message.warning(
          `当前限制选择 50 个图片！`
        );
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].uid === file.uid) {
            if (i == fileList.length - 1) {
              this.picLoading = false;
            }
            fileList.splice(i, 1);
          }
        }
        this.picLoading = false;
        return false;
      }

      
      // if (this.uploadPicList.length > 100) {
      //   this.$message.warning(
      //     `当前限制选择 100 个文件，您选择了 ${this.uploadPicList.length} 个文件`
      //   );
      //   return false;
      // }
      
      if (this.picLength > fileList.length) {
        this.picLength = 0;
      }
      const isLt2M = file.size / 1024 / 1024 < 50;
      // 视频限制上传大小为500MB
      const isLt2M2048 = file.size / 1024 / 1024 < 500;
      // console.log(fileList)
      const type = ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/quicktime","application/msword","application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
      let isJPG = type.indexOf(file.raw.type) > -1;
      
      let fileExt = ""
      if (typeof file.name == 'string') {
          fileExt = file.name
              .split('.')
              .pop()
              .toLowerCase()
      }
      if(fileExt == 'docx' || fileExt == 'doc'){
        isJPG = true
      }
      
      if (!isJPG) {
        this.$message.error(
          "上传格式只能为jpeg，jpg，gif，png，mp4和mov，已为您自动删除不符合要求的资源!"
        );
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].uid === file.uid) {
            if (i == fileList.length - 1) {
              this.picLoading = false;
            }
            fileList.splice(i, 1);
          }
        }
        if (fileList.length === 0) {
          this.picLoading = false;
        }
        return false;
      }
      
      if (file.raw.type == 'video/mp4' || file.raw.type == "video/quicktime") {
        if (!isLt2M2048) {
          this.$message.error(
            "上传视频大小不能超过 500MB，已为您删除了不符合要求的视频!"
          );
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].uid === file.uid) {
              if (i == fileList.length - 1) {
                this.picLoading = false;
              }
              fileList.splice(i, 1);
            }
          }
          if (fileList.length == 0) {
            this.picLoading = false;
          }
          return false;
        }
      } else if(file.raw.type == "image/jpeg" || file.raw.type == "image/png" || file.raw.type == "image/gif"){
        if (!isLt2M) {
          this.$message.error(
            "上传图片大小不能超过 50MB，已为您删除了不符合要求的资源!"
          );
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].uid === file.uid) {
              if (i == fileList.length - 1) {
                this.picLoading = false;
              }
              fileList.splice(i, 1);
            }
          }
          if (fileList.length == 0) {
            this.picLoading = false;
          }
          return false;
        }
      }


      if (file.raw.type == 'video/mp4' || file.raw.type == "video/quicktime") {
        this.isHaveVideo = true
        const bolb = new Blob([file.raw]);//转为一个新的Blob文件流
        this.picList.push({
          name: file.name,
          src: window.URL.createObjectURL(bolb),
          desc: "",
          author: '',
          labelIds: '',
          accessId:'',
          type: 'video',
          file: file,
          // 2待送审  3公开  0私密
          status:this.initUploadStatus?this.isAuditEnabled=='true'?2:3:0,
          isChecked:this.batchOperationFlag
        });
        this.uploadPicList.push({
          name: file.name,
          src: window.URL.createObjectURL(bolb),
          desc: "",
          author: '',
          labelIds: '',
          accessId:'',
          type: 'video',
          file: file,
          // 2待送审  3公开  0私密
          status:this.initUploadStatus?this.isAuditEnabled=='true'?2:3:0,
          isChecked:this.batchOperationFlag
        });
        ++this.picLength;
        if (this.picLength > fileList.length) {
          this.picLength = fileList.length;
        }
        if (this.picLength === fileList.length) {
          this.picLoading = false;
        }
        this.picLoading = false;
        this.$refs.upload.uploadFiles.push(file);

        this.vLength++
        this.batchOperation()

        // _this.videoSrc = window.URL.createObjectURL(bolb);
      } else {
        console.log('批量操作标志1',this.batchOperationFlag);
        var _this = this;
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        var img = new Image();

        reader.onload = function(e) {
          var width = 160, //图像大小
            quality = 0.8, //图像质量
            canvas = document.createElement("canvas"),
            drawer = canvas.getContext("2d");
          img.src = this.result;
          img.onload = function() {
            canvas.width = width;
            canvas.height = width * (img.height / img.width);
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            console.log('批量操作标志2',this.batchOperationFlag);
            
            ++_this.picLength;
            _this.picList.push({
              name: file.name,
              src: canvas.toDataURL("image/png", quality),
              desc: "",
              author: '',
              labelIds: '',
              accessId:'',
              type: 'pic',
              // 2待送审  3公开  0私密
              status:_this.initUploadStatus?_this.isAuditEnabled=='true'?2:3:0,
              file: file,
              isChecked:_this.batchOperationFlag
            });
            if (_this.picLength > fileList.length) {
              _this.picLength = fileList.length;
            }
            if (_this.picLength === fileList.length) {
              _this.picLoading = false;
            }

            // console.log(_this.picLength,fileList.length)
          };

          _this.uploadPicList.push({
            name: file.name,
            src: this.result,
            desc: "",
            author: '',
            labelIds: '',
            accessId:'',
            type: 'pic',
            // 2待送审  3公开  0私密
            status:_this.initUploadStatus?_this.isAuditEnabled=='true'?2:3:0,
            file: file,
            isChecked:_this.batchOperationFlag
          });
        };

        this.pLength++

        this.$refs.upload.uploadFiles.push(file);
        this.batchOperation()
      }
    },

    //点击空白处，关闭图片描述窗口
    removeDesc() {
      this.isUpload = false;
      this.isUploadFlag = -1;
    },

    //图片描述失去焦点之后 把输入内容存放进去
    blurDesc() {
      this.picList[this.isUploadFlag].desc = this.picDescribe;
      this.uploadPicList[this.isUploadFlag].desc = this.picDescribe;
    },

    //图片点击
    picListClick(i,item) {
      //打开图片描述
      // console.log(this.batchOperationFlag);
      if (this.batchOperationFlag) {
        this.handleCheckedChange(item,i)
      }
      this.isUpload = !this.batchOperationFlag?true:false
      //获取点击图片的索引，关闭图片描述之后，把输入内容存放起来
      this.isUploadFlag = i;
      //获取已有描述
      this.picDescribe = this.picList[i].desc;
    },
    //图片点击
    

    //保存并推送
    saveandpush(formName) {
      // console.log(this.picList);
      // console.log(this.uploadPicList);
      if (this.picList.length === 0) {
        this.$message.warning("请选择图片");
        return;
      }
      // this.isHaveVideo

      //隐藏图片描述
      this.isUpload = false;
      this.isUploadFlag = -1;

      this.progress = 0;

      this.picLength = 0;

      // this.$message("正在开发中……");

      this.listAllowPushChannelAsync()

    },

    //保存并上传事件
    save(formName) {
      // console.log(this.atlasForm)
      // return;
      // console.log(this.picList);
      // console.log(this.uploadPicList);
      this.mediaLength =this.picList.length
      console.log('----长度',this.mediaLength);

      if (this.picList.length == 0) {
        this.$message.warning("请选择图片");
        return;
      }
      

      //隐藏图片描述
      this.isUpload = false;
      this.isUploadFlag = -1;
      // this.picList.forEach((item) => {
      //   item.status=this.mediaStatus
      // })
      // this.uploadPicList.forEach((item) => {
      //   item.status=this.mediaStatus
      // })
      this.progress = 0;

      this.picLength = 0;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          //判断是否把文件名作为图片描述
          if (this.isIncludeChinese) {
            for (let i = 0; i < this.uploadPicList.length; i++) {
              let descMy = "";
              this.uploadPicList[i].desc = "";
              // this.picList[i].desc = "";
              let nameMy = this.uploadPicList[i].name.substring(
                0,
                this.uploadPicList[i].name.length - 4
              );
              let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
              //判断当前图片的描述是否为空（因为用户输入的为先，不覆盖）
              if (
                typeof this.uploadPicList[i].desc == "undefined" ||
                this.uploadPicList[i].desc == null ||
                this.uploadPicList[i].desc == ""
              ) {
                if (reg.test(nameMy)) {
                  this.uploadPicList[i].desc = nameMy;
                  this.picList[i].desc = nameMy;
                }
              }
            }
          }
          //新增上传
          if (this.uploadMode === 0) {
            //增加逻辑，新增上传必须添加到归属资源库
            if (this.atlasForm.libId==this.options[0].value&&this.options[0].hasOwnProperty('children')) {
              this.$message.warning('请选择归属资源库！')
              return
            }
            


            //原有功能
            if (this.$route.params.atlas) {
              if (!this.isIncludeChinese) {
                let picdesc
                if (this.$route.params.atlas.desc && this.$route.params.atlas.desc !== this.$route.params.atlas.name) {
                  picdesc =
                    this.$route.params.atlas.name +
                    "-" +
                    this.$route.params.atlas.desc;
                } else {
                  picdesc =
                    this.$route.params.atlas.name
                }

                if (picdesc.length > 200) {
                  picdesc = picdesc.substr(0, 195) + "……";
                }
                for (let i = 0; i < this.uploadPicList.length; i++) {
                  if (!this.uploadPicList[i].desc) {
                    this.uploadPicList[i].desc = picdesc;
                    this.picList[i].desc = picdesc;
                  }

                }
              }
              this.isUploadFlag = 0;
              this.isrouteBtn = true;
              this.loading = true;
              this.uploadLength = this.picList.length;
              this.myUpload();
            } else {
              if (this.atlasForm.name) {
                if (!this.isIncludeChinese) {
                  let picdesc
                  if (this.atlasForm.desc && this.atlasForm.desc !== this.atlasForm.nam) {
                    picdesc = this.atlasForm.name + "-" + this.atlasForm.desc;
                  } else {
                    picdesc = this.atlasForm.name
                  }
                  if (picdesc.length > 200) {
                    picdesc = picdesc.substr(0, 195) + "……";
                  }
                  for (let i = 0; i < this.uploadPicList.length; i++) {
                    if (!this.uploadPicList[i].desc) {
                      this.uploadPicList[i].desc = picdesc;
                      this.picList[i].desc = picdesc;
                    }
                  }
                }
                this.isSave = true;
                this.isrouteBtn = true;
                this.isUploadFlag = 0;
                this.loading = true;
                this.uploadLength = this.picList.length;
                this.addAtlasAsync(this.atlasForm);
              } else {
                let date = new Date();
                let name = this.$store.state.user.loginInfo.name
                let formatDate = formatDateTime(date,'YYYYMMDDhhmm')
                let atlasName = formatDate +'-'+ name
                
                // 没有名称，需要获得名称
                this.$confirm(
                  `此操作，将上传到资源到新建资源夹【${atlasName}】, 是否继续?`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
                  }
                ).then(() => {
                  this.atlasForm.name = atlasName
                  console.log(this.atlasForm);
                  this.isSave = true;
                  this.isUploadFlag = 0;
                  this.isrouteBtn = true;
                  this.loading = true;
                  this.uploadLength = this.picList.length;
                  this.addAtlasAsync(this.atlasForm);
                  // console.log('测试-myLibId',this.myLibId,this.myAtlasId,this.libId,this.atlasId);
                  // this.myUpload();
                });
              }
            }
          } else {
            if (this.myLibId !== 0) {
              if (!this.isIncludeChinese) {
                let picdesc = ''
                if (this.atlasInfo.atlasDesc && this.atlasInfo.atlasDesc !== this.atlasInfo.atlasName) {
                  picdesc =
                    this.atlasInfo.atlasName +
                    "-" +
                    this.atlasInfo.atlasDesc;
                } else {
                  picdesc =
                    this.atlasInfo.atlasName
                }

                if (picdesc.length > 200) {
                  picdesc = picdesc.substr(0, 195) + "……";
                }

                for (let i = 0; i < this.picList.length; i++) {
                  if (!this.picList[i].desc) {
                    this.uploadPicList[i].desc = picdesc;
                    this.picList[i].desc = picdesc;
                  }
                }
              }
              this.libId = this.myLibId;
              this.atlasId = this.myAtlasId;
              this.isSave = true;
              this.isUploadFlag = 0;
              this.alreadyUpload = 0;
              this.uploadLength = 0;
              this.isrouteBtn = true;
              this.loading = true;
              this.uploadLength = this.picList.length;
              this.myUpload();
            } else {
              this.$message.warning("请选择资源夹");
            }
          }
        } else {
          return false;
        }
      });
    },

    //自定义上传
    myUpload(text) {
      this.kuai = Math.ceil(100 / this.uploadPicList.length);
      // console.log(param)
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      // console.log('kuai',this.kuai)

      for (let i = 0; i < this.uploadPicList.length; i++) {
        if (this.uploadPicList[i].file.size > 4000000) {
          bytesPerPiece = 1000000;
        } else {
          bytesPerPiece = 528888;
        }

        // fileMD5 = this.$md5(this.uploadPicList[i].file.raw)

        // await this.getFileInfoByHashAsync(
        //   fileMD5,
        //   this.uploadPicList[i].file.raw,
        //   bytesPerPiece,
        //   totalPieces,
        //   i
        // );

        getMD5(this.uploadPicList[i].file.raw, (md5) => {
          fileMD5 = md5;

          this.getFileInfoByHashAsync(
            fileMD5,
            this.uploadPicList[i].file.raw,
            bytesPerPiece,
            totalPieces,
            i,
            text,

            this.uploadPicList[i].type,
            this.uploadPicList[i].name,
            
          );
        });
      }
      console.log('上传完毕！！！');
    },

    //分片上传
    async fragmentation(val, blob, bytesPerPiece, totalPieces, i, text, type,name) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      let fileProgress = 0;

      totalPieces = Math.ceil(filesize / bytesPerPiece);


      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }
        console.log('执行');
        if (!this.canUploadFlag) break
        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val,
        };

        // console.log(formData, chunk);

        fileProgress = parseFloat((this.kuai / totalPieces).toFixed(2));

        // console.log('fileProgress',fileProgress)
        if (index < totalPieces) {
          // console.log('分片次数',index)
          await this.uploadPicChunkAsync(
            params,
            formData,
            blob,
            i,
            fileProgress
          );
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val,
          };
          await this.uploadPicChunkMergeAsync(params, blob, i, text, type,name);
        }
        start = end;
        index++;
      }
    },


    //去除后缀名
    getExt(filename) {
        if (typeof filename == 'string') {
            return filename
                .split('.')
                .shift()
                
        } else {
            throw new Error('filename must be a string type')
        }
    },

    //上传成功之后，创建对象
    afterUploadAdd(id, i, text, type, path, name) {
      // console.log(id, i, text, type, path, name); 
      if (this.$route.params.atlas) {
        // this.libId=this.libId[this.libId.length-1]
        this.libId=this.$route.params.atlas.libId
      }
      let picMsg = {
        atlasId: this.atlasId,
        fileId: id,
        libId: this.libId,
        desc: "",
        createUid: this.createUid,
        tags: ''
      };
      // console.log('我想下班+++',picMsg);
      // console.log(this.uploadPicList);
      
      if (this.uploadPicList[i]) {
        console.log(this.uploadPicList[i], 'iiiii' + i);
        // 增加分类id
        if (this.uploadPicList[i].hasOwnProperty('accessId')) {
          if (
            this.uploadPicList[i].accessId !== null ||
            this.uploadPicList[i].accessId !== ""
          ) {
            picMsg.accessId = this.uploadPicList[i].accessId;
          }
        }

        if (this.uploadPicList[i].hasOwnProperty('labelIds')) {
          if (
            this.uploadPicList[i].labelIds !== ""
          ) {
            picMsg.labelIds = this.uploadPicList[i].labelIds;
          }
        }
        // console.log('状态------',this.uploadPicList[i].status);
        if (this.uploadPicList[i].hasOwnProperty('status')) {
          {
            picMsg.status = this.uploadPicList[i].status;
          }
        }

        if (this.uploadPicList[i].hasOwnProperty('author')) {
          if (
            this.uploadPicList[i].author !== ""
          ) {
            picMsg.author = this.uploadPicList[i].author;
          }
        }



        if (this.uploadPicList[i].hasOwnProperty('desc')) {
          if (
            this.uploadPicList[i].desc !== null ||
            this.uploadPicList[i].desc !== ""
          ) {
            picMsg.desc = this.uploadPicList[i].desc;
            
            // console.log(this.uploadPicList[i].desc)
          }
        }
      }

      if(path){
        picMsg.path = picPrefix + path
      }

      // console.log(this.picList[this.isUploadFlag].desc)
      // console.log("刚上传",picMsg)
      this.picList.splice(this.isUploadFlag, 1);

      if (type == 'pic') {
        
        this.addPictureAsync(picMsg, text);
      //   if (i == this.uploadPicList.length-1) {
      //   console.log('最后查看了图片。。。。。');    
      // }
      } else if (type == 'video'){
        this.addVideoAsync(picMsg, text);
        
      } 
      // console.log('长度变化',this.picIds.length  ,this.videoIds.length);
      


    },

    //滚动设置picinf为fixed
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // var scroll = scrollTop - this.i;
      // this.i = scrollTop;
      // console.log('scrollTop',scrollTop)
      if (scrollTop >= 216) {
        this.picinfClass = "picinf picinfpos";
        this.picdescribeClass = "picdescribe picdescribepos";
      } else {
        this.picinfClass = "picinf";
        this.picdescribeClass = "picdescribe";
      }
    },

    //获取手机上传url
    async getMobileUpdateUrlAsync() {
      let { status, data, message } = await getMobileUpdateUrl();
      if (status) {
        let powers = JSON.stringify(this.powersList);
        let date = new Date(data.expirationTime);
        date = date.getTime(date);
        let qrcode = new QRCode("erweima", {
          width: 251,
          height: 259,
          text:
            this.privateDomain 
            +
            data.url +
            "?token=" +
            data.token +
            "&date=" +
            date +
            "&createUid=" +
            this.createUid +
            "&haveTimeOut=false" // 二维码地址
          // text: ' http://localhost:8080' + data.url + "?token=" + data.token + '&date=' + date + '&createUid=' + this.createUid + "&haveTimeOut=false", // 二维码地址
          // text: 'http://192.168.187.195:8080/public/mobileUpdate?eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJSb3V0ZXJTb2Z0Q2RwIiwiZXhwIjoxNTkyODgxNzkxLCJ1c2VySWQiOjYwMDAwLCJpYXQiOjE1OTI4Nzk5OTF9.rO_qfy2jf2gDl_w0K_XFb2dBK07H_Gm6kvxjBErMl28', // 二维码地址
        });
      }
    },
    //获取应用基础配置
    async getAppBaseConfigAsync() {
      let { status, data, message } = await getAppBaseConfig();
      if (status) {
        // this.isAuditEnabled = localStorage.getItem('isAuditEnabled');
        let isAuditEnabled = JSON.parse(localStorage.getItem('isAuditEnabled'));
        let netIsAuditEnabled = data.auditEnabled == null ? false : true
        if (isAuditEnabled != netIsAuditEnabled) {
          logout(3)
        }
        
        this.privateDomain = data.privateDomain;
      }
    },

    

    //直接上传
    async uploadPicAsync(val, i) {
      var paramData = new FormData();
      paramData.append("file", val);
      let { status, data, message } = await uploadPic(paramData);
      if (status) {
        this.afterUploadAdd(data.id, i,data.savepath);
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync(params, val, blob, i, fp) {
      // console.log(params, val);
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        this.canUploadFlag = false
        this.$message.error(message)
        this.loading = false 
        this.isrouteBtn = false;   
        this.isSave = false;   
        
        // this.uploadPicAsync(blob,i);
        // this.uploadErrorLength++
      } else {
        // console.log("分片第一步");
        this.progress = parseFloat((this.progress + fp).toFixed(2));
        // console.log('progress',this.progress)
        if (this.progress > 99) {
          this.progress = 99;
        }
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync(params, blob, i, text, type,name) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (status) {
        this.afterUploadAdd(data.id, i, text, type,data.savepath,name);
      } else {
        this.uploadErrorLength++;
        this.myErrorList.push(this.picList[this.isUploadFlag]);

        // console.log("分片合并的错误图片列表", this.myErrorList);
        this.picList.splice(this.isUploadFlag, 1);
        // console.log(blob);
        // this.uploadPicAsync(blob,i);
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsync(val, blob, b, t, i, text, type,name) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (status) {
        this.afterUploadAdd(data.id, i, text, type,data.savepath,name);
        this.progress += this.kuai;
        if (this.progress > 99) {
          this.progress = 99;
        }
      } else {
        this.fragmentation(val, blob, b, t, i, text, type,name);
      }
    },

    //创建图集
    async addAtlasAsync(val, text) {
      let libArr = val.libId
      if(Array.isArray(libArr) && libArr.length >= 2){
        val.parentLibId = parseInt(libArr[0])
        val.libId = parseInt(libArr[1])
      }else if(Array.isArray(libArr) && libArr.length == 1){
        val.parentLibId = 0
        val.libId = parseInt(libArr[0])
      }else{
        val.libId = libArr
      }
      val.createUid=this.createUid
      let { status, data, message, errors } = await addAtlas(val);
      if (status) {
        this.atlasId = data.id;
        this.libId = data.libId;
        this.searchAtlasAsync({
          pageSize: 20,
          page: 0,
          createUid: this.createUid,
        });
        this.myUpload(text);

        this.$refs["ruleForm"].resetFields();
        this.atlasForm.libId = this.options[0].value;
      } else {
        this.picList = [];
        this.progress = 100;
        this.loading = false;
        this.isrouteBtn = false;
        this.alreadyUpload = 0;
        this.uploadMode = 0;
        this.myLibId = 0;
        this.myAtlasId = 0;
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
        this.reload();
      }
    },

    //创建视频对象
    async addWordAsync(val,text) {
      if(window.location.origin == 'http://digital-media.xcmg.com:9090'){
        let arr=val.path.replace(window.location.origin,'')
        val.path='http://10.1.4.6:9090' + arr
      }
      let { status, data, message, errors } = await save(val);
      if (this.isUploadFlag === this.picList.length) {
        this.picList = [];
        if (this.$route.params.atlas) {
          this.isSave = true;
        } else {
          this.isSave = false;
        }
      }
      if (!status) {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message:  "有" +
              this.uploadErrorLength +
              "个资源上传出错!" });

        this.uploadErrorLength++;
        this.myErrorList.push(this.picList[this.isUploadFlag]);
      }
      this.alreadyUpload++;


      console.log(this.alreadyUpload,this.picList,this.uploadErrorLength);
      if (
        this.uploadLength === this.alreadyUpload ||
        this.picList.length === 0
      ) {
        this.picList = [];
        this.uploadPicList = [];
        this.picLength = 0;
        this.progress = 100;
        this.loading = false;
        this.isrouteBtn = false;
        this.alreadyUpload = 0;
        this.vLength = 0;
        this.pLength = 0;
        this.wLength = 0;
        this.uploadLength = 0;
        this.uploadMode = 0;
        this.myLibId = 0;
        this.myAtlasId = 0;
        this.isSave = false;
        if (this.uploadErrorLength !== 0) {
          this.setErrorList(this.myErrorList);
          // sessionStorage.setItem('errorList',JSON.stringify(this.errorList))
          this.$message.warning({
            message:
              "有" +
              this.uploadErrorLength +
              "张出错，请重新上传，其余已上传成功！",
            duration: 3000,
          });
          setTimeout(() => {
            if (this.$store.state.user.errorList) {
              this.myErrorList = [];
              this.uploadErrorLength = 0;
              this.picList = this.$store.state.user.errorList;
              this.uploadPicList = this.$store.state.user.errorList;
              // console.log(this.picList,this.uploadPicList)
              this.setErrorList(null);
            }
          }, 200);
        } else {
          this.$message.success("上传成功！");
          if(this.$route.params.atlas){
            this.$router.go(-1)
          }
          // this.$router.go(0)
        }
        this.$refs.upload.uploadFiles = [];
        if (this.$refs.dragupload) {
          this.$refs.dragupload.uploadFiles = [];
        }
        if (this.$refs.dragupload1) {
          this.$refs.dragupload1.uploadFiles = [];
        }
        if (text) {
          this.pushPic()
        }

      }
    },

    //创建视频对象
    async addVideoAsync(val,text) {
      let { status, data, message, errors } = await addVideo(val);
      if (this.isUploadFlag === this.picList.length) {
        this.picList = [];
        if (this.$route.params.atlas) {
          this.isSave = true;
        } else {
          this.isSave = false;
        }
      }
      if (!status) {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      } else {
        if (val.status==2) {
          this.videoIds.push(data.id)  
        }
      }
      this.alreadyUpload++;
      // if (i == this.uploadPicList.length-1) {
      //     console.log('最后查看了视频。。。。。');    
      //   } 
      if (
        this.uploadLength === this.alreadyUpload 
      ) {
        console.log('最后上传的状态--视频-1。。。。。')
        if (this.isAuditEnabled=='true') {
          if (this.picIds.length > 0 || this.videoIds.length > 0) {
            setTimeout(async () => {
              let params = {
                status: 2
              }
              if (this.picIds.length>0) {
                params.picIds=this.picIds.join(',')
              }
              if (this.videoIds.length>0) {
                params.videoIds=this.videoIds.join(',') 
              } 
              let result = await batchCheck(params)
              if (result.status) {
                console.log('sucess');
                this.picIds = [];
                this.videoIds = [] ;
              } else {
                console.log('error')
                this.picIds = [];
                this.videoIds = [] ;
              }  
            },1000)
          }
          
        }
        
        // console.log(this.picIds,this.videoIds);
        this.picList = [];
        this.uploadPicList = [];
        this.picLength = 0;
        this.progress = 100;
        this.loading = false;
        this.isrouteBtn = false;
        this.alreadyUpload = 0;
        this.vLength = 0;
        this.pLength = 0;
        this.wLength = 0;
        this.uploadLength = 0;
        this.uploadMode = 0;
        this.myLibId = 0;
        this.myAtlasId = 0;
        this.isSave = false;
        if (this.uploadErrorLength !== 0) {
          this.setErrorList(this.myErrorList);
          // sessionStorage.setItem('errorList',JSON.stringify(this.errorList))
          this.$message.warning({
            message:
              "有" +
              this.uploadErrorLength +
              "张出错，请重新上传，其余已上传成功！",
            duration: 3000,
          });
          setTimeout(() => {
            if (this.$store.state.user.errorList) {
              this.myErrorList = [];
              this.uploadErrorLength = 0;
              this.picList = this.$store.state.user.errorList;
              this.uploadPicList = this.$store.state.user.errorList;
              // console.log(this.picList,this.uploadPicList)
              this.setErrorList(null);
            }
          }, 200);
        } else {
          this.$message.success("上传成功！");
          console.log("上传成功！");
          
          if(this.$route.params.atlas){
            this.$router.go(-1)
          }
          // this.$router.go(0)
        }
        this.$refs.upload.uploadFiles = [];
        if (this.$refs.dragupload) {
          this.$refs.dragupload.uploadFiles = [];
        }
        if (this.$refs.dragupload1) {
          this.$refs.dragupload1.uploadFiles = [];
        }
        if (text) {
          this.pushPic()
        }

      }
      
      
    },


    //创建图片对象
    async addPictureAsync(val, text) {
      let { status, data, message, errors } = await addPicture(val);
      if (this.isUploadFlag=== this.picList.length) {
        this.picList = [];
        if (this.$route.params.atlas) {
          this.isSave = true;
        } else {
          this.isSave = false;
        }
      }
      if (!status) {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        this.$message.error({ message: message + errortext });
      } else {
        if (val.status==2) {
          this.picIds.push(data.id) 
        }
        
      }
      this.alreadyUpload++;
      

      // console.log('图片对象内容',this.uploadLength === this.alreadyUpload,this.uploadLength,this.alreadyUpload)
      if (
        this.uploadLength === this.alreadyUpload
      ) {
        this.picList = [];
        console.log('最后上传的状态--图片-1。。。。。')
        if (this.isAuditEnabled == 'true') {
          if (this.picIds.length > 0 || this.videoIds.length > 0) {
            setTimeout(async () => {
              let params = {
              status: 2
              }
              if (this.picIds.length>0) {
                params.picIds=this.picIds.join(',')
              }
              if (this.videoIds.length>0) {
                params.videoIds=this.videoIds.join(',') 
              } 
              let result = await batchCheck(params)
              if (result.status) {
                console.log('sucess');
                this.picIds = [];
                this.videoIds = [] ;
              } else {
                console.log('error')
                this.picIds = [];
                this.videoIds = [] ;
              }  
            },1000)
          }
        }  
          
        
        
        this.uploadPicList = [];
        this.picLength = 0;
        this.progress = 100;
        this.loading = false;
        this.isrouteBtn = false;
        this.vLength = 0;
        this.pLength = 0;
        this.wLength = 0;
        this.alreadyUpload = 0;
        this.uploadLength = 0;
        this.uploadMode = 0;
        this.myLibId = 0;
        this.myAtlasId = 0;
        this.isSave = false;
        if (this.uploadErrorLength !== 0) {
          this.setErrorList(this.myErrorList);
          // sessionStorage.setItem('errorList',JSON.stringify(this.errorList))
          this.$message.warning({
            message:
              "有" +
              this.uploadErrorLength +
              "张出错，请重新上传，其余已上传成功！",
            duration: 3000,
          });
          setTimeout(() => {
            if (this.$store.state.user.errorList) {
              this.myErrorList = [];
              this.uploadErrorLength = 0;
              this.picList = this.$store.state.user.errorList;
              this.uploadPicList = this.$store.state.user.errorList;
              // console.log(this.picList,this.uploadPicList)
              this.setErrorList(null);
            }
          }, 200);
        } else {
          this.$message.success("上传成功！");
            console.log("上传成功！");
            if(this.$route.params.atlas){
              this.$router.go(-1)
            }
          }
        this.$refs.upload.uploadFiles = [];
        if (this.$refs.dragupload) {
          this.$refs.dragupload.uploadFiles = [];
        }
        if (this.$refs.dragupload1) {
          this.$refs.dragupload1.uploadFiles = [];
        }
        // this.reload();


        if (text) {
          this.pushPic()
        }
        // this.$router.go(0);
      }

      // console.log('12131',this.alreadyUpload)
    },

    //获取图片库列表
    async listLibAsync() {
      let { status, data, message } = await listLib({ pageSize: 1000 });
      if (status) {
        this.options = [];
      if (localStorage.getItem("createUid") == 60000) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            this.options.push({
              value: data[i].id,
              label: data[i].name,
              children:[]
            });
          }
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.options.push({
                value: data[i].id,
                label: data[i].name,
                children:[]
              });
            }
          }
        }
      }
      if (this.$route.params.atlas) {
        if(this.$route.params.atlas.parentLibId == 0){
          this.atlasForm.libId = this.$route.params.atlas.libId;
        }else{
          this.atlasForm.libId = [this.$route.params.atlas.parentLibId,this.$route.params.atlas.libId.toString()];
        }
      } else if (this.options.length > 0) {
        this.atlasForm.libId = this.options[0].value;
      }


      for (let i = 0;i < this.options.length;i++) {
        let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.options[i].value == this.allowLib[j].split('-')[0]){
                flag++
                this.options[i].children.push({
                  value: this.allowLib[j].split('-')[1],
                  label: ''
                })
              }
            }
            
          }
          if(flag == 0){
            delete this.options[i].children
          }
      }

      for (let i = 0; i < this.options.length; i++) {
        if(this.options[i].hasOwnProperty('children')){
          if(this.options[i].children.length > 0){
            let spliceNum = []
            for (let z = 0; z < this.options[i].children.length; z++) {
              for (let j = 0; j < data.length; j++) {
                if(data[j].id == this.options[i].children[z].value){
                  if(data[j].status === 1){
                    this.options[i].children[z].label = data[j].name
                  }else{
                    spliceNum.push(z)
                  }
                }
                
              }
              
            }

            for (let index = 0; index < spliceNum.length; index++) {
              this.options[i].children.splice(spliceNum[index] - index,1)
            }
            
            //没有子集 删除children
            if (this.options[i].children.length == 0) {
                delete this.options[i].children;
            }
          }
        }
      }
      } else {
        this.$message.error('【归属资源库】模块'+message);
      }
      

    },


    //获取个人图集
    async searchAtlasAsync(val) {
      let { status, data, message } = await searchAtlas(val);
      if (status) {
        this.myAtlas = [];
        for (let i = 0; i < data.length; i++) {
          this.myAtlas.push({
            name:
              "[" +
              (data[i].libInfo ? data[i].libInfo.name : "暂无") +
              "] " +
              data[i].name,
            date: formatConversion(data[i].createAt.toString()),
            libId: data[i].libId,
            atlasId: data[i].id,
            atlasName: data[i].name,
            atlasDesc: data[i].desc,
          });
        }
        // this.myAtlasId = this.myAtlas[0].label;
      } else {
        // this.$message.error(message);
      }
    },


    async createAsync() {
      let { status, data, message } = await selectList();
      if (status) {
        console.log(data);
      }
    },
    // 获取标签列表
    async listLabelAsync () {
      let { status, data, message } = await getLabelListApi({ status:1,pageSize: 100 });
      if (status) {
        this.labelList = data
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    // 获取分类列表
    async listClassifyAsync () {
      let { status, data, message } = await getClassifyListApi({ status:1,pageSize: 100 });
      if (status) {
        this.classifyList = data
      } else {
        console.log(message);
      }
    },



  },
  created() {
    // if (this.picList.length < 1) {
    //   this.picFlag = false;
    // }
    
    // 判断是否需要走审核流程
        this.isAuditEnabled = localStorage.getItem('isAuditEnabled');
    
    if(powersObj.allowMyGallery){
      if(powersObj.createAtlas){
        if(powersObj.createPublicAtlas){
          this.isAdd = true
        }
      }
    }
    this.listLabelAsync()
    this.listClassifyAsync()
    // this.createAsync()


    // this.addWordAsync(abc)

    //获取图片邀约
    this.listPictureNeedAsync();

    this.getAppBaseConfigAsync();

    this.listLibAsync();

    this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid });

    this.documentHeight = document.documentElement.clientHeight;

    if (this.documentHeight <= 650) {
      this.minRows = 0;
      this.maxRows = 1;
    } else if (this.documentHeight <= 775) {
      this.minRows = 3;
      this.maxRows = 6;
    } else if (this.documentHeight <= 970) {
      this.minRows = 6;
      this.maxRows = 10;
    }

    // console.log(this.$route.params.atlas);
    

    let createLength = 0;

    if (powersObj.createPrivateAtlas) {
      this.statusFlag = true;
      this.atlasForm.status = "1";
    } else {
      createLength++;
    }
    if (powersObj.createPublicAtlas) {
      this.statusFlag = true;
      this.atlasForm.status = "1";
    } else {
      createLength++;
    }

    if (createLength == 2) {
      this.isSave = true;
      this.statusFlag = true;
      this.isrouteBtn = true;
      this.isIncludeChineseFlag = false;
      this.$message.warning("请联系管理员添加可见性的权限！");
    }

    if (createLength == 0) {
      this.statusFlag = false;
      this.atlasForm.status = "1";
    }
    if (this.$route.params.atlas) {
      if(this.$route.params.atlas.parentLibId == 0){
        this.atlasForm.libId = this.$route.params.atlas.libId;
      }else{
        this.atlasForm.libId = [this.$route.params.atlas.parentLibId,this.$route.params.atlas.libId.toString()];
      }
      this.atlasForm.name = this.$route.params.atlas.name;
      this.atlasForm.desc = this.$route.params.atlas.desc || "暂无";
      this.atlasForm.status = String(this.$route.params.atlas.status);
      this.atlasId = this.$route.params.atlas.id;
      if(this.$route.params.atlas.parentLibId == 0){
        this.libId = this.$route.params.atlas.libId;
      }else{
        this.libId = [this.$route.params.atlas.parentLibId,this.$route.params.atlas.libId.toString()];
      }
      // this.libId = this.$route.params.atlas.libId;
      this.isSave = true;
      this.isIncludeChineseFlag = true;
    }

  },
  mounted() {
    // this.qrcode()
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./picupload.scss";
@import "@/constants/elHeader.scss";
::v-deep .el-select__caret:before {
  content: "\e78f";
  font-size: 16px;
  color: black;
}

.elinput ::v-deep .el-input__inner {
  height: 45px;
  line-height: 45px;
}

.piclist ::v-deep .upload-demo,
.piclist ::v-deep .el-upload,
.piclist ::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
  border: none;

}

.batcch-operation{
  padding: 10px 10px;
  width: 100%;
  // height: 100px;
  // background-color: pink;
  display: flex;
  align-items: center;

  .operation-btn{
    display: flex;
    flex-wrap: nowrap;
  }
}

::v-deep .el-transfer-panel{
        width: 300px  !important;
}

::v-deep .el-transfer__buttons{
  padding:0 5px !important;
  display:inline-grid;

  .el-button{
    margin-left: 0 !important;
  }
  
  
}

::v-deep .el-transfer-panel__body{
        height: 400px  !important;
}
::v-deep   .el-transfer-panel__list{
  height: 350px !important;
}

::v-deep .el-loading-spinner {
  top: 400px;
}
//设置滚动条样式
::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 32px;
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 3px;
  width: 20px;
  // height: 20px;    /* 滚动条滑块长度 */
  background-color: #ccc;
}
/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
.el-table ::v-deep .el-table__body tr td {
  cursor: pointer;
}
.el-table ::v-deep .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table ::v-deep .el-table__body .current-row td .cell {
  color: #fff !important;
}
.is-checked ::v-deep .el-checkbox__inner {
  background-color: #3cb035 !important;
  border-color: #3cb035;
}
.is-checked ::v-deep .el-checkbox__label {
  color: #606266;
}
// .el-radio-group ::v-deep .is-active .el-radio-button__inner {
//   background: #185ed3;
//   border-color: #185ed3;
// }
</style>
